var render, staticRenderFns
import script from "./associated_customer_three_replace_position.vue?vue&type=script&lang=js"
export * from "./associated_customer_three_replace_position.vue?vue&type=script&lang=js"
import style0 from "./associated_customer_three_replace_position.vue?vue&type=style&index=0&id=422d6742&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422d6742",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('422d6742')) {
      api.createRecord('422d6742', component.options)
    } else {
      api.reload('422d6742', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/user_management/form/associated_customer/associated_customer_three_replace_position.vue"
export default component.exports